import { Trans, useLingui } from '@lingui/react/macro';

import InputText from '@/design_system/InputText';
import Stack from '@/design_system/Stack';
import Title from '@/design_system/Typography/Title';
import { type Product } from '@/models/product';

import './ColorsWithImageSection.css';

export const ExternalId = ({
  product,
  isEditing,
  externalId,
  setExternalId,
  isInvalid,
}: {
  product: Product;
  isEditing: boolean;
  externalId: string | null;
  setExternalId: (externalId: string | null) => void;
  isInvalid: boolean;
}) => {
  if (isEditing) {
    return (
      <ExternalIdInput
        externalId={externalId}
        setExternalId={setExternalId}
        isInvalid={isInvalid}
      />
    );
  }

  return <ExternalIdReadonly product={product} />;
};

const ExternalIdReadonly = ({ product }: { product: Product }) => {
  return (
    <Stack gap="0.5rem">
      <Title as="h2" size="400" weight="medium">
        <Trans id="settings.organization.data-catalogs.products.product.external-id">
          Internal identifier
        </Trans>
      </Title>

      {product.externalId}
    </Stack>
  );
};

const ExternalIdInput = ({
  externalId,
  setExternalId,
  isInvalid,
}: {
  externalId: string | null;
  setExternalId: (externalId: string | null) => void;
  isInvalid: boolean;
}) => {
  const { t } = useLingui();

  return (
    <Stack gap="0.5rem">
      <Title as="h2" size="400" weight="medium">
        <Trans id="settings.organization.data-catalogs.products.product.external-id">
          Internal identifier
        </Trans>
      </Title>

      <InputText
        aria-label={t({
          id: 'settings.organization.data-catalogs.products.product.external-id',
          message: 'Internal identifier',
        })}
        value={externalId ?? undefined}
        onChange={setExternalId}
        isInvalid={isInvalid}
      />
    </Stack>
  );
};
